import { useSelector } from 'react-redux'

export const useIsSnapshotMode = () => {
    // @ts-expect-error redux store is not typed properly
    const isSnapshotMode = useSelector((state) => !!state?.strategy?.sourceId)

    return isSnapshotMode === true
}
